import { render } from "./DetalleTicket.vue?vue&type=template&id=f8ba232c&scoped=true"
import script from "./DetalleTicket.vue?vue&type=script&lang=js"
export * from "./DetalleTicket.vue?vue&type=script&lang=js"

import "./DetalleTicket.vue?vue&type=style&index=0&id=f8ba232c&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ba232c"]])

export default __exports__